import notificationsRepository from "../repositories/NotificationsRepository";
import { buildSearchParams } from "../utils/requestHelpers";

export class NotificationsService {
  static GetOfferNotifications(instance, userId, showCompleted, continuationToken) {
    const repo = new notificationsRepository;
    const params = buildSearchParams(
      {
        userId: userId,
        showsCompleted: showCompleted,
        pageSize: 20,
        token: continuationToken && encodeURIComponent(continuationToken),
        notificationType: "CarrierOffer"
      }
    ); 

    return repo.getOfferNotifications(instance, params);
  }

  static GetNewOfferNotifications(instance, userId) {
    const repo = new notificationsRepository;
    const params = buildSearchParams(
      {
        userId: userId,
        notificationType: "NewOfferNotification"
      }
    ); 

    return repo.getNewOfferNotifications(instance, params);
  }

  static UpdateOfferNotification(instance, payload) {
    const repo = new notificationsRepository;

    return repo.updateOfferNotification(instance, payload);
  }

  static UpdateAllNotificationsAsRead(instance, userId, notificationType, orderId) {
    const repo = new notificationsRepository;
    const params = buildSearchParams(
      {
        userId: userId,
        orderId: orderId,
        notificationType: notificationType
      }
    ); 

    return repo.updateAllNotificationsAsRead(instance, params);
  }
}